import { getIdFromPath } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { NotAllowed } from "../components/not-allowed";
import { ImportTemplatesPage } from "./import-templates-page";
import { ImportTemplatesWizardPage } from "./import-wizard/import-templates-wizard-page";

export const ImportTemplatesRoutes = () => {
    const current = getIdFromPath(3);
    const id = getIdFromPath(4);

    return <>
        {
            !current && Can(UserEntitlementCatalogs.ViewImportModelTab) ? <ImportTemplatesPage /> :
                current === 'new' && Can(UserEntitlementCatalogs.ViewCreateNewImportModelButton) ? <ImportTemplatesWizardPage /> :
                    current === 'edit' && Can(UserEntitlementCatalogs.EditImportModelPage) && id !== '' ? <ImportTemplatesWizardPage id={id} /> :
                        <NotAllowed />
        }
    </>
}
